import { Checkbox, Divider, Typography } from "antd"
import { useTranslation } from "react-i18next"

import styles from "../CreditsAutomationConnectGuide.module.less"

const { Text } = Typography

// Matches the Figma "Confirm invitation" step: a caption divider above a
// single checkbox confirming the merchant sent the team@chargeback.io invite.
export const ConfirmInvitationCheckbox = ({ team, checked, onChange }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.confirmInvitation}>
      <Divider orientation="left" plain className={styles.confirmDivider}>
        {t("Confirm invitation")}
      </Divider>
      <Checkbox
        className={styles.confirmCheckbox}
        checked={checked}
        onChange={(e) => onChange?.(e.target.checked)}
      >
        <Text className={styles.confirmLabel}>
          {t("I’ve added team@chargeback.io to my _team_ team with the required access.", { team })}
        </Text>
      </Checkbox>
    </div>
  )
}
